// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { UserRole } from './user-role';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class User extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayRoles() {
        let roles = null;
        if (!!this.userRoles) {
            const userRoles = _(this.userRoles).orderBy('role.name');
            userRoles.forEach((x) => {
                if (!!roles) roles += `  --  ${x.role.name}`;
                else roles = x.role.name;
            });
        }
        return roles;
    }

    jwtToken?: string;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  active!: boolean;
  email?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  passwordSalt?: string;
  quickbooksAccessToken?: string;
  quickbooksCode?: string;
  quickbooksRealmId?: string;
  quickbooksRefreshToken?: string;
  quickbooksState?: string;
  userName?: string;
  userRoles!: UserRole[];
}

